/* Sticky mobile add-to-cart: appears when the real buy button scrolls out
   of view, proxies clicks back to it so all Dawn form logic stays intact. */
(function () {
  var bar = document.querySelector('[data-kso-sticky-atc]');
  if (!bar || !('IntersectionObserver' in window)) return;

  var submit = document.getElementById(bar.dataset.submitId);
  if (!submit) return;

  var observer = new IntersectionObserver(
    function (entries) {
      var visible = entries[0].isIntersecting;
      bar.classList.toggle('is-visible', !visible);
      bar.setAttribute('aria-hidden', visible ? 'true' : 'false');
    },
    { rootMargin: '-80px 0px 0px 0px' }
  );
  observer.observe(submit);

  bar.querySelector('button').addEventListener('click', function () {
    var current = document.getElementById(bar.dataset.submitId);
    if (current && !current.disabled) {
      current.click();
      current.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  });
})();
